export default function getNodeBackgroundImage(node) {
  if (node) {
    return { width: node.offsetWidth, height: node.offsetHeight }
  } else {
    return null
  }
}
